document.addEventListener("DOMContentLoaded", function () {
  // Skip on mobile
  if (/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) return;

  const cursor = document.createElement("div");
  cursor.id = "custom-cursor";
  cursor.style.position = "fixed";
  cursor.style.top = "0px";
  cursor.style.left = "0px";
    cursor.style.width = "60px";
  cursor.style.height = "60px";
cursor.style.backgroundImage = `url(${window.customCursorImage})`;
cursor.style.backgroundSize = "100% 100%"; // forces exact scaling
cursor.style.backgroundRepeat = "no-repeat";
cursor.style.backgroundColor = "transparent"; // just in case
  cursor.style.backgroundSize = "contain";
  cursor.style.backgroundRepeat = "no-repeat";
  cursor.style.pointerEvents = "none";
  cursor.style.zIndex = "999999";
  cursor.style.transform = "translate(-20%, -20%)";

  document.body.appendChild(cursor);

  document.addEventListener("mousemove", function (e) {
    cursor.style.left = e.clientX + "px";
    cursor.style.top = e.clientY + "px";
  });
});
